import React, { useState } from 'react';
import { Form, Input, Button, Upload, Avatar, Alert, message, Spin } from 'antd';
import { UploadOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';

const RegistrarUsuario = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState(null);  // para guardar el archivo seleccionado
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alerta, setAlerta] = useState({ tipo: '', mensaje: '', visible: false });

  const handleFileChange = ({ fileList }) => {
    if (!fileList.length) {
      setFileList(null);
      setPreviewImage(null);
      return;
    }

    const file = fileList[0].originFileObj;
    if (!file) return;

    setFileList(fileList[0]);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleRemove = () => {
    setFileList(null);
    setPreviewImage(null);
    form.setFieldsValue({ avatar: null });
  };

  const onFinish = async (values) => {
    setLoading(true);
    setAlerta({ visible: false });

    try {
      const formData = new FormData();
      formData.append('nombre_completo', values.nombre_completo);
      formData.append('celular', values.celular || '');
      formData.append('correo_electronico', values.correo_electronico);
      formData.append('contrasena', values.contrasena);

      if (fileList) {
        formData.append('avatar', fileList.originFileObj);
      }

      const response = await axios.post(
        'https://elarigestion-production.up.railway.app/api/registrar-usuario',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      message.success('🎉 Usuario registrado correctamente');
      setAlerta({ tipo: 'success', mensaje: response.data.message, visible: true });
      form.resetFields();
      setFileList(null);
      setPreviewImage(null);
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Error al registrar usuario';
      message.error('❌ ' + errorMsg);
      setAlerta({ tipo: 'error', mensaje: errorMsg, visible: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: 'auto' }}>
      <h2>Registro de Usuario</h2>

      {alerta.visible && (
        <Alert
          message={alerta.mensaje}
          type={alerta.tipo}
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Form.Item label="Avatar" name="avatar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Avatar
              size={64}
              src={previewImage}
              icon={!previewImage && <UserOutlined />}
              alt="Avatar preview"
            />

            <Upload
              accept="image/*"
              beforeUpload={() => false}
              showUploadList={false}
              onChange={handleFileChange}
              fileList={[]} // para evitar control interno
            >
              <Button icon={<UploadOutlined />}>Seleccionar Imagen</Button>
            </Upload>

            {previewImage && (
              <Button danger onClick={handleRemove}>
                Eliminar
              </Button>
            )}
          </div>
        </Form.Item>

        <Form.Item
          name="nombre_completo"
          label="Nombre completo"
          rules={[{ required: true, message: 'Por favor ingresa tu nombre completo' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="celular" label="Celular">
          <Input />
        </Form.Item>

        <Form.Item
          name="correo_electronico"
          label="Correo electrónico"
          rules={[
            { required: true, message: 'Por favor ingresa tu correo electrónico' },
            { type: 'email', message: 'Correo electrónico inválido' },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="contrasena"
          label="Contraseña"
          rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Registrar Usuario
          </Button>
        </Form.Item>
      </Form>

   
    </div>
  );
};

export default RegistrarUsuario;
